import React from "react";

import { coverageOptionsURL } from "EmployerApplication/urls";
import { quotePageURL } from "QuotePage/urls";
import { connect } from "react-redux";
import { reduxForm, SubmissionError } from "redux-form";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";
import focusFirstError from "Utils/focusFirstError";
import { validateRequired, validateEmail, validatePassword } from "Utils/Validations";

import BodyText from "Common/BodyText";
import { CardHeader, CardSection } from "Common/Card";
import { SIFormField } from "Common/forms";
import { Row } from "Common/Grid";
import NavigationControls from "Common/NavigationControls";
import { appendAuthParams } from "Common/TokenAuth/Utils";

type Props = {
  companyIdToken: string;
  showSiAccount: boolean;
  handleSubmit: () => void;
};

const IntuitSignInButton = ({ companyIdToken }: { companyIdToken: string }) => (
  <a href={`/quickbooks/authenticate?company_token=${companyIdToken || ""}`}>
    <img src="/assets/IntuitSignIn-lg-blue-no-logo@2x.jpg" style={{ height: "35px" }} />
  </a>
);

const CreateAccountSection = () => (
  <CardSection>
    <BodyText size="medium" mb={4}>
      If you don't have a Quickbooks Account to connect to, you can create an account with SimplyInsured here.
    </BodyText>
    <Row>
      <SIFormField name="email" label="Email Address" type="email" sm={5} validate={[validateEmail, validateRequired]} />
    </Row>
    <Row>
      <SIFormField name="password" label="Password" props={{ type: "password" }} sm={5} validate={[validateRequired, validatePassword]} />
    </Row>
  </CardSection>
);

export const CreateAccountStep = ({ companyIdToken, showSiAccount, handleSubmit }: Props) => (
  <form onSubmit={handleSubmit}>
    <CardHeader>Connect Your QuickBooks Account</CardHeader>
    <CardSection>
      <BodyText size="medium" mb={4}>
        Sign in to your QuickBooks Account to automatically import your data.
      </BodyText>
      <IntuitSignInButton companyIdToken={companyIdToken} />
    </CardSection>
    {showSiAccount && (
      <>
        <CardHeader>Create Account</CardHeader>
        <CardSection px={0}>
          <CreateAccountSection />
        </CardSection>
      </>
    )}

    {showSiAccount && <NavigationControls backLink={quotePageURL()} useRoutedBackButton={false} saveButtonText="Create Account" />}
  </form>
);

const submitAccount = (values) =>
  fetchWithCSRFToken(`/api/v2/accounts/update_credentials`, {
    method: "PUT",
    body: JSON.stringify(values),
    processData: false,
  })
    .then((response) => response.json())
    .then((response: { success: boolean; errors: {} }) => {
      if (!response.success) {
        throw new SubmissionError(response.errors);
      }
    });

const withReduxForm = reduxForm({
  form: "createAccount",
  onSubmit: submitAccount,
  onSubmitSuccess: () => {
    window.location.href = appendAuthParams(`/intuit/router${coverageOptionsURL}`);
  },
  onSubmitFail: (errors) => focusFirstError(errors, ","),
});

const withRedux = connect(null);
export default withReduxForm(withRedux(CreateAccountStep));
